import { Theme } from '@radix-ui/themes'
import * as React from 'react'
import Modal from 'react-modal'
import Button from 'components/ui/button'
import type { ModalStyle } from 'components/utils/modalStyles'
import AddToDiscoSuccessIcon from '../add-to-disco-success-icon'
import styles from './index.module.css'

export default class AddToDiscoSuccessModal extends React.PureComponent<{
  onClose: () => unknown
  modalStyle: ModalStyle
}> {
  render(): React.ReactElement<typeof Modal> {
    return (
      <Modal
        isOpen
        onRequestClose={this.props.onClose}
        style={this.props.modalStyle}
      >
        <Theme>
          <div className={styles.addToDiscoSuccessModalCont}>
            <div>
              <AddToDiscoSuccessIcon />
            </div>
            <div className={styles.addToDiscoSuccessModalTitle}>Success!</div>
            <div className={styles.addToDiscoSuccessModalMessage}>
              <div>We’re adding this music to your DISCO.</div>
              <div>
                You’ll get a notification in the app when it’s finished
                transferring.
              </div>
            </div>
            <div className={styles.addToDiscoSuccessModalCloseCont}>
              <Button caption="Close" onClick={this.props.onClose} />
            </div>
          </div>
        </Theme>
      </Modal>
    )
  }
}
